import styled from "styled-components";

export const StylesIconButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0px;
  width: 48px;
  height: 48px;
  justify-content: center;
  position: relative;
  z-index: 1;

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.3" : "1")};
`;
